import { z } from 'zod';
// [task 30a36f5] What a strategist RUN concluded.
//
// Lives here rather than in mag-strategist.ts because that file is the
// agent's OUTPUT shape, and most of these outcomes happen before the
// agent is ever called (no_brain, no_seeds, no_platforms) or after it
// returns (validators_blocked, reviewer_blocked).
//
// It lives in schemas rather than in apps/api because TWO sides need one
// declaration. The api had it right all the way to the wire —
// run-strategist.ts declared it, run-now.ts typed the response envelope
// with it, server.ts returned it verbatim — and then the dashboard
// re-declared the field as a bare `string`, so adding an outcome
// silently degraded to the generic toast line with no type error
// anywhere. That bit twice in one session: platform_error and
// unsupported_geo_or_language both needed hand-added copy and nothing
// would have caught a forgotten case.
//
// Same reasoning as DEFAULT_WINDOW_BY_TIER (commit eb5f5c82): when two
// sides must agree, two copies is how they stop agreeing.
/** Outcome of one strategist run. A zod enum rather than a bare TS union
 *  so the wire response can eventually be validated rather than cast —
 *  today `RunStrategistNowResponse` is asserted, not parsed. */
export const runStrategistOutcomeSchema = z.enum([
    /** A proposal was persisted. The only success. */
    'proposal_created',
    // ── Refusals before the agent runs ──────────────────────────────
    'no_brain',
    'no_seeds',
    'no_platforms',
    'no_marketing_url',
    'no_budget_headroom',
    /** Keyword research found nothing because a platform ANSWERED and had
     *  nothing. Distinct from platform_error — see below. */
    'no_data',
    /** Geo or language could not be resolved to a platform id, so the
     *  call was refused rather than guessed. Declared on
     *  RunKeywordResearchResult long before anything could assign it;
     *  reachable since task eaa6c37. */
    'unsupported_geo_or_language',
    /** A platform was called and the call FAILED — sunset api version,
     *  expired token, quota wall, timeout. The whole point of task
     *  eaa6c37: until this existed a broken integration reported
     *  'no_data' and the founder read it as a quiet market. */
    'platform_error',
    // ── The agent ran ───────────────────────────────────────────────
    'agent_no_signal',
    'agent_crashed',
    'validators_blocked',
    'reviewer_blocked',
    'all_clusters_cooled_down',
]);
//# sourceMappingURL=strategist-run-outcome.js.map